// import Hero from "../Accueil/Hero.jsx";

import "../Services/Services.css";
import Nav from "../general/nav.jsx";
import Form from "../Contact/Form.jsx";

import AboveFooter from "../general/AboveFooter.jsx";
import Footer from "../general/Footer.jsx";

export default function Accueil() {
  return (
    <>
      <Nav />
      <Form />
      <AboveFooter />
      <Footer />
    </>
  );
}
